"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinsModernTightened = SpinsModernTightened;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SpinsHeader = require("./SpinsHeader");
var _classnames = _interopRequireDefault(require("classnames"));
var _reactMintl = require("@godaddy/react-mintl");
var _DomainEntries = _interopRequireDefault(require("./SpinResults/DomainEntries"));
var _uxUtils = require("@site/ux-utils");
var _utils = require("./utils");
var _SpinAddToCartButton = _interopRequireDefault(require("./SpinResults/SpinAddToCartButton"));
var _sharedComponents = require("@site/shared-components");
var _RequestApiType = _interopRequireDefault(require("./constants/RequestApiType"));
var _useApiData = require("./hooks/useApiData");
var _LoadingEmptyStateContent = _interopRequireDefault(require("./components/LoadingEmptyStateContent"));
var _SpinsComponentLoader = require("./SpinsComponentLoader");
// eslint-disable-next-line complexity
function SpinsModernTightened(props) {
  const {
    language = {}
  } = {
    ...props
  };
  const {
    overrideProps,
    languageStrings
  } = (0, _sharedComponents.useComponentDataProvider)(language);
  const {
    spinsResponse = {},
    options = {},
    ctaProps = {},
    AddToCartButton,
    CustomCartStateBadge,
    PriceBlock,
    hideBottomPadding = false,
    showTopBorder = false,
    showBottomBorder = false,
    enableDynamicFontScaling = false,
    eidPrefix,
    cartContents,
    requestApiType,
    apm,
    customLoadingSpinner,
    emptyStateComponent,
    onSuccessApiData,
    spinsHeaderComponent,
    SpinInCartExpandedComponent = () => /*#__PURE__*/_react.default.createElement("div", null)
  } = {
    ...props,
    ...overrideProps
  };
  const {
    spinsData,
    requestStatus
  } = (0, _useApiData.useApiData)(requestApiType, {
    ...options,
    ...options.extraApiParam
  }, apm, onSuccessApiData);
  const spinsResponseData = requestApiType ? spinsData : spinsResponse;
  const {
    market = 'en-US',
    showFreeIndicator,
    spinsHeader: {
      showSpinsHeader
    } = {},
    maxSpins = 40,
    cart,
    widerSpacing = false
  } = options;
  const dataCy = 'spins-modern-tightened';
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  const showLoadMoreButton = false;
  const dbsPrice = spinsResponse?.DbsPrice;
  const recommendedDomains = (0, _utils.transformSpinData)({
    findResponse: spinsResponseData,
    showFreeIndicator,
    maxSpins,
    cart
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "styled-spins-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
    locale: market,
    key: market,
    messages: languageStrings
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": dataCy,
    className: (0, _classnames.default)('spin-and-filter-wrap', {
      'px-2': widerSpacing,
      'card-view': isMobile,
      'pb-4': !isMobile && !showLoadMoreButton && !hideBottomPadding
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('spin-header', {
      'justify-content-between': showSpinsHeader,
      'justify-content-end': !showSpinsHeader
    })
  }, showSpinsHeader && /*#__PURE__*/_react.default.createElement(_SpinsHeader.SpinsHeader, {
    options: options
  }), spinsHeaderComponent), /*#__PURE__*/_react.default.createElement(_LoadingEmptyStateContent.default, {
    requestApiType,
    requestStatus,
    emptyStateComponent,
    customLoadingSpinner,
    recommendedDomains
  }), showTopBorder && recommendedDomains.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "bd-t-1 bd-white"
  }), recommendedDomains.length > 0 && /*#__PURE__*/_react.default.createElement(_DomainEntries.default, {
    language: languageStrings,
    recommendedDomains: recommendedDomains,
    dataCy: "tight-modern-spin",
    options: options,
    ctaProps: {
      apiKey: options?.apiKey,
      env: options?.env,
      ...ctaProps
    },
    CustomCartStateBadge: CustomCartStateBadge,
    PriceBlock: PriceBlock,
    AddToCartButton: AddToCartButton,
    enableDynamicFontScaling: enableDynamicFontScaling,
    eidPrefix: eidPrefix,
    cartContents: cartContents,
    dbsPrice: dbsPrice,
    SpinInCartExpandedComponent: SpinInCartExpandedComponent,
    apm: apm
  }), showBottomBorder && recommendedDomains.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "bd-t-1 bd-white"
  })), showLoadMoreButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center justify-content-center pb-3"
  })));
}
const ctaPropsPropTypes = {
  ..._SpinAddToCartButton.default.propTypes
};
delete ctaPropsPropTypes.product;
SpinsModernTightened.propTypes = {
  language: _propTypes.default.object,
  spinsResponse: _propTypes.default.object,
  options: _propTypes.default.object,
  AddToCartButton: _propTypes.default.func,
  PriceBlock: _propTypes.default.func,
  hideBottomPadding: _propTypes.default.bool,
  showTopBorder: _propTypes.default.bool,
  showBottomBorder: _propTypes.default.bool,
  enableDynamicFontScaling: _propTypes.default.bool,
  eidPrefix: _propTypes.default.string,
  forceEnableBFF: _propTypes.default.bool,
  ctaProps: _propTypes.default.shape(ctaPropsPropTypes),
  CustomCartStateBadge: _propTypes.default.element,
  cartContents: _propTypes.default.shape({
    has: _propTypes.default.func
  }),
  requestApiType: _propTypes.default.oneOf(_RequestApiType.default),
  apm: _propTypes.default.object,
  customLoadingSpinner: _propTypes.default.element,
  emptyStateComponent: _propTypes.default.element,
  onSuccessApiData: _propTypes.default.func,
  spinsHeaderComponent: _propTypes.default.element,
  SpinInCartExpandedComponent: _propTypes.default.element
};
const SpinsModernTightenedWithComponentDataProvider = props => {
  const {
    appName,
    apiKey,
    plid,
    urlOverride,
    options: {
      enableFavorites
    } = {},
    uipProps,
    forceEnableBFF
  } = props;
  return /*#__PURE__*/_react.default.createElement(_sharedComponents.ComponentDataProvider, (0, _extends2.default)({
    appName: appName,
    componentName: "spins",
    apiKey: apiKey,
    forceEnableBFF: forceEnableBFF,
    loader: /*#__PURE__*/_react.default.createElement(_SpinsComponentLoader.SpinsComponentLoader, null)
  }, enableFavorites && {
    uipProps: {
      plid,
      urlOverride,
      ...uipProps
    }
  }), /*#__PURE__*/_react.default.createElement(SpinsModernTightened, props));
};
SpinsModernTightenedWithComponentDataProvider.propTypes = {
  ...SpinsModernTightened.propTypes,
  uipProps: _propTypes.default.object,
  forceEnableBFF: _propTypes.default.bool
};
var _default = exports.default = SpinsModernTightenedWithComponentDataProvider;